export default {"src":"/_next/static/media/0x3ee2200efb3400fabb9aacf31297cbdd1d435d47.76268e6e.svg","height":347,"width":375,"blurWidth":0,"blurHeight":0};